class UserGroup {
    static Admin = 1
    static Agent = 2
    static Regular = 3
}

export default UserGroup;